import React from 'react';

import classNames from 'classnames';

import {
  LayoutExtensionContainer,
} from '../../containers/LayoutExtensionContainer/LayoutExtensionContainer';
import { Animations, Modal } from '../Modal/Modal';
import { TypographVariant, Typography, TypographySize } from '../Typography/Typography';
import styles from './NarrowModal.module.css';

export type Props = {
  backBtnClassName?: string;
  children: string | JSX.Element;

  closeBtnClassName?: string;
  hasBackBtn?: boolean;
  isOpen: boolean;

  modalContentClassName?: string;
  modalContentWrapperClassName?: string;
  modalHeaderClassName?: string;
  onBack?: () => void;

  onClose: () => void;

  shouldCloseOnEsc?: boolean;
  title?: string | JSX.Element;
  titleClassName?: string;
  titleSize?: TypographySize;
  titleVariant?: TypographVariant;
};

export const NarrowModal = React.memo((props: Props) => {
  const {
    isOpen,
    onClose,

    hasBackBtn,
    backBtnClassName,
    onBack,

    title = ' ',
    titleVariant = 'h4',
    titleSize,
    titleClassName,

    children,

    modalContentClassName,
    modalContentWrapperClassName,
    modalHeaderClassName,
    closeBtnClassName,
    shouldCloseOnEsc = false,
  } = props;

  return (
    <LayoutExtensionContainer>
      {({ isMobileLayout }) => (
        <Modal
          shouldCloseOnEsc={shouldCloseOnEsc}
          isMobileLayout={isMobileLayout}
          isOpen={isOpen}
          onClose={onClose}
          hasBackBtn={hasBackBtn}
          backBtnClassName={classNames(styles.backBtn, backBtnClassName)}
          onBack={onBack}
          modalContentWrapperClassName={{
            base: classNames(
              styles.modalContentWrapper,
              modalContentWrapperClassName,
            ),
          }}
          animation={{
            desktop: Animations.opacity,
            mobile: Animations.fromDownToTop,
          }}
          modalContentClassName={classNames(
            styles.modalContent,
            modalContentClassName,
          )}
          header={
            title && (
              <div className={classNames(styles.modalHeader, modalHeaderClassName)}>
                <Typography
                  variant={titleVariant}
                  size={titleSize}
                  className={titleClassName}
                >
                  {title}
                </Typography>
              </div>
            )
          }
          closeBtnClassName={closeBtnClassName}
        >
          <div className={styles.modalChildren}>
            {children}
          </div>
        </Modal>
      )}
    </LayoutExtensionContainer>
  );
});

NarrowModal.displayName = 'NarrowModal';
